import PartnerDetailsTab from './PartnerDetailsTab'
import PartnerPayoutsTab from './PartnerPayoutsTab'
import PartnerSignupsTab from './PartnerSignupsTab'
import PartnerCampaignsTab from './PartnerCampaignsTab'
import PartnerCampaignDetailsTab from './PartnerCampaignDetailsTab'

export {
  PartnerDetailsTab,
  PartnerPayoutsTab,
  PartnerSignupsTab,
  PartnerCampaignsTab,
  PartnerCampaignDetailsTab,
}
